import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppRouterService {

  constructor(
  ) { }


  navigateToViewer(activityId: string, inNewTab: boolean = false) {
    const origin = window.location.origin;
    const path = origin + '/viewer/' + activityId;
    if (inNewTab) {
      window.open(path);
      return;
    }
    window.location.href = path;
  }

  navigateToDesignerLogin(activityId: string) {

    const origin = window.location.origin;
    window.location.href = origin + '/designer/auth?activityId=' + activityId;

  }
}
